import { render, staticRenderFns } from "./echarK.vue?vue&type=template&id=620cd890"
import script from "./echarK.vue?vue&type=script&lang=js"
export * from "./echarK.vue?vue&type=script&lang=js"
import style0 from "./echarK.vue?vue&type=style&index=0&id=620cd890&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports